import React, { useContext } from 'react'
import { TunnelDataContext } from '../context/TunnelDataContext';

export const withTunnelDataContext = (WrappedPage) => {
    return (props) => {
        const { tunnelData, onSetStep, setTunnelData } = useContext(TunnelDataContext);

        return <WrappedPage {...props} tunnelData={tunnelData} onSetStep={onSetStep} setTunnelData={setTunnelData}/>
    }
}